import { AutogenLayoutJobClassCodeLookup } from "./autogen/AutogenLayoutJobClassCodeLookup";

export class JobClassCodeLookup extends AutogenLayoutJobClassCodeLookup {
}
